/*
  TODO: remember to uninstall packages: "browserslist" and "caniuse-lite",
    installed temporary regarding https://github.com/facebook/create-react-app/issues/7239
*/

import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore, historyH } from './store';
import Layout from './Layout';
import Routes from './Routes';
import './fontAwesome';
import 'react-splitter-layout/lib/index.css';
import './globalStyles.css';

const store = configureStore();

const App = () => (
  <Provider {...{ store }}>
    <Router history={historyH}>
      <Layout>
        <Routes />
      </Layout>
    </Router>
  </Provider>
);

render(
  <App />,
  // eslint-disable-next-line no-undef
  document.getElementById('app'),
);
